import ROUTE from '@/api/route'
import POINT from "@/api/point";

const state = {
    routes: [],
    projects: [],
}
const getters = {

}

const mutations = {
    SET_ROUTES: (state, routes) => {
        state.routes = routes
    },
    SET_PRO: (state, projects) => {
        state.projects = projects
    }
}

const actions = {
    getRoutes: ({ commit, state }) => {
        return new Promise((resolve, reject) => {
            if (Array.isArray(state.routes) && state.routes.length > 0) {
                resolve('success');
            } else {
                ROUTE.getRoutes().then(res => {
                    if (res.status === 'success') {
                        commit("SET_ROUTES", res.content)
                        resolve('success');
                    } else {
                        reject("获取线路失败")
                    }
                })
            }
        })
    },
    setProjects: ({ commit }) => {
        POINT.listPoints().then((res) => {
            if (res.status === 'success') {
                commit('SET_PRO', res.content);
            }
        });
    },
    setRoutes: ({ commit }) => {
        ROUTE.getRoutes().then(res => {
            if (res.status === 'success') {
                commit('SET_ROUTES', res.content);
            }
        })
    }


}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
